import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight, FaImages } from 'react-icons/fa';
import '../../styles/MinisterialAward2026.css';

export default function MinisterialAward2026() {
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);

  // Award ceremony gallery. 15 photo slides + a closing slide linking to the
  // full album. `img` is null until the client supplies the photos — a null
  // entry renders a branded placeholder instead of a broken image.
  const gallery = [
    ...Array.from({ length: 15 }, (_, i) => ({
      img: null,
      caption: `Ceremony highlight ${i + 1}`,
    })),
    {
      img: null,
      caption: 'View the full ceremony album',
      albumUrl: null,
      isAlbumSlide: true,
    },
  ];

  const goToSlide = (index) => {
    const total = gallery.length;
    setActiveSlide(((index % total) + total) % total);
  };

  const nominees = [
    { img: 'philip-edward.jpg', name: 'Hon. Philip Edward "Brave" Davis KC, MP' },
    { img: 'dickon-mitchell.jpg', name: 'Hon. Dickon Mitchell' },
    { img: 'jonathan-reid.jpg', name: 'Senator Jonathan Reid' },
    { img: 'michel-chebat.jpg', name: 'Hon. Michel Chebat' },
    { img: 'charles-cooper.jpg', name: 'Hon. Charles Cooper' },
    { img: 'konris-maynard.jpg', name: 'Hon. Konris Maynard' },
    { img: 'dominic-smith.jpg', name: 'Hon. Dominic Smith' },
  ];

  return (
    <div className='ma2026-page'>
      {/* Banner / Video Section */}
      <div className='ma2026-banner'>
        <img
          src='/assets/ministerial_awards/winner_2026.jpg'
          alt='CANTO Ministerial Awards for ICT Leadership & Digital Transformation'
        />
      </div>

      {/* Header Section Below Video */}
      <div className='ma2026-header'>
        <div className='ma2026-header-title'>
          CANTO Ministerial Awards for ICT Leadership & Digital Transformation
        </div>
        <div className='ma2026-header-subtitle'>
          Celebrating Visionary Ministers Advancing the Caribbean's Digital Future
        </div>
      </div>

      {/* About / Introduction */}
      <div className='ma2026-about'>
        <div className='ma2026-about-label'>About the Awards</div>
        <div className='ma2026-about-text'>
          The CANTO Ministerial Awards for ICT Leadership & Digital Transformation shines a spotlight on visionary Ministers who are boldly advancing the region's digital future. Celebrating exceptional leadership, the awards recognize those turning ambition into action, driving innovation, expanding connectivity, and unlocking opportunities for citizens and businesses alike. More than an accolade, it's a powerful call to action, inspiring governments to place ICT at the heart of sustainable development, inclusive growth, and a thriving digital society.
        </div>
        <button
          onClick={() => setShowAboutModal(true)}
          className='ma2026-about-btn'
        >
          About the Awards
        </button>
      </div>

      {/* Nominees */}
      <div className='ma2026-nominees'>
        <div className='ma2026-nominees-label'>Meet the Nominees</div>
        <div className='ma2026-nominees-title'>Nominees for Caribbean Digital Excellence</div>
        <div className='ma2026-nominees-grid'>
          {nominees.map((nominee) => (
            <div className='ma2026-nominee-card' key={nominee.img}>
              <img
                src={`/assets/ministerial_awards/nominees/${nominee.img}`}
                alt={nominee.name}
                loading='lazy'
              />
            </div>
          ))}
        </div>
      </div>

      {/* Ceremony Gallery Carousel */}
      <div className='ma2026-gallery'>
        <div className='ma2026-gallery-label'>Award Ceremony</div>
        <div className='ma2026-gallery-title'>Moments from the Ceremony</div>

        <div className='ma2026-gallery-stage'>
          <button
            type='button'
            className='ma2026-gallery-arrow ma2026-gallery-arrow-prev'
            onClick={() => goToSlide(activeSlide - 1)}
            aria-label='Previous photo'
          >
            <FaChevronLeft />
          </button>

          <div className='ma2026-gallery-viewport'>
            <div
              className='ma2026-gallery-track'
              style={{ transform: `translateX(-${activeSlide * 100}%)` }}
            >
              {gallery.map((slide, i) => (
                <div className='ma2026-gallery-slide' key={i}>
                  {slide.img ? (
                    <img src={slide.img} alt={slide.caption} loading='lazy' />
                  ) : (
                    <div className='ma2026-gallery-placeholder'>
                      <FaImages />
                      <span className='ma2026-gallery-placeholder-title'>
                        {slide.isAlbumSlide ? 'Full Album' : `Photo ${i + 1}`}
                      </span>
                      <span className='ma2026-gallery-placeholder-note'>
                        {slide.isAlbumSlide
                          ? 'Album link coming soon'
                          : 'Ceremony photo coming soon'}
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <button
            type='button'
            className='ma2026-gallery-arrow ma2026-gallery-arrow-next'
            onClick={() => goToSlide(activeSlide + 1)}
            aria-label='Next photo'
          >
            <FaChevronRight />
          </button>
        </div>

        <div className='ma2026-gallery-caption'>
          <span className='ma2026-gallery-counter'>
            {activeSlide + 1} / {gallery.length}
          </span>
          {gallery[activeSlide].caption}
        </div>

        <div className='ma2026-gallery-dots'>
          {gallery.map((slide, i) => (
            <button
              type='button'
              key={i}
              className={`ma2026-gallery-dot${i === activeSlide ? ' ma2026-gallery-dot-active' : ''}`}
              onClick={() => goToSlide(i)}
              aria-label={`Go to photo ${i + 1}`}
            />
          ))}
        </div>
      </div>

      {/* Next Call for Nominations */}
      <div className='ma2026-guidelines'>
        <div className='ma2026-guidelines-label'>Coming Soon</div>
        <div className='ma2026-guidelines-heading'>
          Stay tuned for the CANTO 2028 "Call for Nominations"
        </div>
        <div className='ma2026-guidelines-text'>
          The CANTO Ministerial Awards for ICT Leadership &amp; Digital Transformation are
          conferred biennially. Nomination guidelines for the 2028 cycle will be published here.
        </div>
      </div>

      {/* Footer Alert */}
      <div className='ma2026-footer-alert'>
        <div className='ma2026-footer-alert-divider' />
        <div className='ma2026-footer-contact'>
          For Additional Information email: <a href='mailto:canto@canto.org'>canto@canto.org</a>
        </div>
        <div className='ma2026-footer-subject'>
          Subject: CANTO Ministerial Awards
        </div>
      </div>

      {/* About Modal */}
      {showAboutModal && (
        <div className='ma2026-modal-overlay' onClick={() => setShowAboutModal(false)}>
          <div className='ma2026-modal-content' onClick={(e) => e.stopPropagation()}>
            <button className='ma2026-modal-close' onClick={() => setShowAboutModal(false)}>
              ×
            </button>
            <h2 className='ma2026-modal-title'>About the Awards</h2>
            <div className='ma2026-modal-text'>
              <p>
                In the defining era of the digital economy, visionary leadership at the ministerial level has emerged as a decisive force shaping the future of nations. Across the Caribbean, Ministers responsible for Information and Communication Technologies stand at the forefront of transformation—guiding policy, expanding connectivity, and ensuring that digital innovation drives inclusive prosperity, resilience, and sustainable development.
              </p>
              <p>
                As the region's premier association representing the telecommunications and ICT ecosystem, CANTO recognizes that progress in the digital age is driven by bold leadership, strategic vision, and a commitment to collaboration across sectors and borders. It is therefore both fitting and necessary to honour those Ministers whose stewardship is accelerating the digital transformation of their nations and strengthening the Caribbean's collective position in the global digital landscape.
              </p>
              <p>
                The CANTO Ministerial Awards for ICT Leadership & Digital Transformation stands as a distinguished recognition of exceptional ministerial leadership. Conferred on a biennial basis, the awards celebrate those whose actions have advanced digital policy, expanded access to technology, and catalyzed innovation that benefits citizens, industries, and governments alike. Beyond recognition, the awards seek to inspire continued leadership in positioning ICT as a central pillar of economic growth, social inclusion, and regional competitiveness.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
